import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "@app/services";

import * as endpoints from "./endpoints";
import {
  finedTestDrive,
  finedTestDriveFailed,
  finedTestDriveSuccess,
  locationFindAll,
  locationFindAllFailed,
  locationFindAllSuccess,
  orderBookTestDrive,
  orderBookTestDriveFailed,
  orderBookTestDriveSuccess,
  userInfo,
  userInfoFailed,
  userInfoSuccess,
} from "./slice";

//--------------------FindTestDriveSaga-------------------------

function* findTestDriveSaga(action: ReturnType<typeof finedTestDrive>): any {
  try {
    const response = yield call(request.get, `${endpoints.finedTestDrive}`);
    yield put(finedTestDriveSuccess(response.data));
  } catch (error: any) {
    yield put(finedTestDriveFailed(error));
  }
}

//--------------------LocationFindAllSagas-------------------------

function* locationFindAllSagas(
  action: ReturnType<typeof locationFindAll>
): any {
  try {
    const response = yield call(request.get, `${endpoints.locationFindAll}`);
    yield put(locationFindAllSuccess(response.data));
  } catch (error: any) {
    yield put(locationFindAllFailed(error));
  }
}

//--------------------BookTestDriveSagas-------------------------

function* orderBookTestDriveSagas(
  action: ReturnType<typeof orderBookTestDrive>
): any {
  try {
    const response = yield call(
      request.post,
      endpoints.orderBookTestDrive,
      action.payload
    );
   
    yield put(orderBookTestDriveSuccess(response.data));
  } catch (error: any) {
    yield put(orderBookTestDriveFailed(error));
  }
}

//--------------------UserInfoSagas-------------------------

function* userInfoSagas(action: ReturnType<typeof userInfo>): any {
  try {
    const response = yield call(request.post, endpoints.userInfo, action.payload);
    yield put(userInfoSuccess(response.data));
  } catch (error: any) {
    yield put(userInfoFailed(error));
  }
}

function* testDriveSagas() {
  yield all([takeLatest(finedTestDrive, findTestDriveSaga)]);
  yield all([takeLatest(locationFindAll, locationFindAllSagas)]);
  yield all([takeLatest(orderBookTestDrive, orderBookTestDriveSagas)]);
  yield all([takeLatest(userInfo, userInfoSagas)]);
}

export { testDriveSagas };
